module.exports = __webpack_public_path__ + "static/media/casaNoturna.f7ab7c84.svg";